import { AuthGuard } from './guard/auth.guard';
import { UserService } from './user/user.service';
import { AgentService } from './agent/agent.service';
import { ChartService } from './chart/chart.service';
import { MachineService } from './machine/machine.service';
import { AuthService } from './auth/authentication.service';
import { CustomerService } from './customer/customer.service';
import { DataWorkService } from './data-work/data.work.service';
import { DataEnergyService } from './data-energy/data.energy.service';
import { DataStateService } from './data-state/data.state.service';
import { ErrorHandlingService } from './error-handling/error.handling.service';
import { AuthenticationTokenStorageService } from './session-storage/authentication.token.storage.service';
import { ImageService } from './image/image.service';
import { ApiInfoService } from './api-info/api-info.service';
import { JobOrderService } from './job/job.order.service';
import { LabelService } from './label/label.service';
import { DataWorkByLabelService } from './data-work-by-label/data.work.by.label.service';

export const services: any[] = [
  AuthGuard,
  AuthService,
  UserService,
  ChartService,
  AgentService,
  MachineService,
  CustomerService,
  DataEnergyService,
  DataWorkService,
  DataWorkByLabelService,
  DataStateService,
  ErrorHandlingService,
  AuthenticationTokenStorageService,
  ImageService,
  ApiInfoService,
  JobOrderService,
  LabelService,
];

export * from './guard/auth.guard';
export * from './user/user.service';
export * from './agent/agent.service';
export * from './chart/chart.service';
export * from './machine/machine.service';
export * from './label/label.service';
export * from './customer/customer.service';
export * from './auth/authentication.service';
export * from './data-energy/data.energy.service';
export * from './data-work/data.work.service';
export * from './data-work-by-label/data.work.by.label.service';
export * from './data-state/data.state.service';
export * from './error-handling/error.handling.service';
export * from './interceptor/authentication.interceptor';
export * from './session-storage/authentication.token.storage.service';
export * from './image/image.service';
export * from './api-info/api-info.service';
export * from './feature-toggle/feature.toggle.service';
